import React from 'react'
import { Navigate } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import { useAuth } from '../../contexts/AuthContext'

const isAdminRoles = (roles: string[] | undefined | null) => {
  const list = roles ?? []
  return list.some((r) => ['admin', 'administrator'].includes(String(r).toLowerCase()))
}

const AdminProtectedRoute: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { user, isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return (
      <Box sx={{ minHeight: '60dvh', display: 'grid', placeItems: 'center' }}>
        <CircularProgress />
      </Box>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/?login=1" replace />
  }

  if (!isAdminRoles(user?.roles)) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}

export default AdminProtectedRoute

